export enum PermissionType {
    User = 1,
    Admin = 2,
}
